import App from '@/models/App'

export default class ShipLaborDashboardWarningSetting extends App {
    static get entity() {
        return 'ShipLaborDashboardWarningSetting'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static fields() {
        return {
            id: this.attr(''),
            shipId: this.attr(''),
            userId: this.attr(''),
            isWorkingTime: this.attr(''),
            workingDays: this.attr(''),
            workingHours: this.attr(''),
            isRestingTime: this.attr(''),
            restingDays: this.attr(''),
            resingHours: this.attr(''),
            isOverworkingTime: this.attr(''),
            overworkingDays: this.attr(''),
            overworkingHours: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            save(shipId, params) {
                return this.post(
                    `${shipId}/labor/dashboard/warning/setting/saved`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
